import React, { useState, useContext, useEffect } from 'react';
import {
  FormGroup,
  Card,
  CardBody,
  Row,
  Col,
} from 'reactstrap';
import cogoToast from 'cogo-toast';
import { useForm } from 'react-hook-form';
import CurrencyInput from 'react-currency-input-field';
import CustomInput from 'reactstrap/lib/CustomInput';
import { EnvironmentContext } from '../../../context/Context';
import DetailRow from '../../../components/GestionPersonaEmpresa/personDetails/DetailRow';
import FalconCardHeader from '../../../components/common/FalconCardHeader';
import { DesembolsoContext } from '../DesembolsoContext';
import WizardInput from '../../../components/auth/wizard/WizardInput';
import { desembolsoServices } from '../../../services';
import { formatterId } from '../../../helpers/formatters';

const WireTransferSection = () => {
  const environment = useContext(EnvironmentContext);
  const { register, setValue, getValues, errors } = useForm({
    defaultValues: {
      wireTransferValue: 0,
    }
  });
  const context = useContext(DesembolsoContext);
  const { loading, selected, handleWireTransferData } = context;

  const [originAccounts, setOriginAccounts] = useState([]);
  const [destAccounts, setDestAccounts] = useState([]);

  useEffect(() => {
    loadBankAccounts();
  }, [environment])

  useEffect(() => {
    if (!selected) return;
    loadClientAccounts();
    onSetData()
  }, [selected])

  const loadBankAccounts = async () => {

    if(!environment.bankAccounts) return;
    const tempOriginAccounts = environment.bankAccounts.map(account => ({
      value: account.idCuenta,
      label: `${account.nroCuenta} - ${account.nombreBanco}`
    }))

    setOriginAccounts(tempOriginAccounts);
  }

  const loadClientAccounts = () => {
    const tempDestAccounts = selected.terceroFinanciera.map(account => ({
      value: account.id,
      label: `${account.numeroCuenta} - ${account.infoBanco}`
    }))
    
    setDestAccounts(tempDestAccounts);
  }

  const onChange = async e => {
    let { name, value } = e;
    if(!value){
      value = '0';
    }
    value = Number(value.replaceAll(",", "."))
    setValue(name, value);
    onSetData();
  }

  const onSetData = () => {
    const formData = getValues();
    const { originAccount, destAccount } = formData;
    if(!originAccount || !destAccount){
      handleWireTransferData(null)
      return;
    }
    handleWireTransferData(formData);
  }

  return (
    <Card className={`my-3`} >
      <FalconCardHeader title="Transferencia Bancaria"></FalconCardHeader>
      <CardBody className="bg-light border-top px-4">
        {selected ? (
          <form>
            <Row>
              <Col lg={4}>
                <DetailRow title="Valor Transferencia Bancaria">
                  <FormGroup className="pr-4">
                    <CurrencyInput
                      className="form-control pl-2"
                      allowNegativeValue={false}
                      name="wireTransferValue"
                      id="wireTransferValue"
                      prefix='$'
                      intlConfig={{ locale: 'es-CO', currency: 'COP' }}
                      {...register('wireTransferValue')}
                      onValueChange={(value) => onChange({ name: 'wireTransferValue', value })}
                      decimalScale={2}
                      maxLength={20}
                      placeholder="$ 0.00"
                      tabIndex="7" />
                  </FormGroup>
                </DetailRow>
                <DetailRow childrenClasses="pr-3" title={`${selected.tipoIdCliente} ${formatterId(selected.idCliente)}`}>{selected.nomCliente || <span className='p-2'></span>}</DetailRow>
              </Col>

              <Col lg={8}>
                <DetailRow title="Cuenta y Banco Origen">
                  <FormGroup className="pr-4">
                    <WizardInput
                      className="pl-2"
                      type="select"
                      tag={CustomInput}
                      placeholder="Seleccionar"
                      id="originAccount"
                      name="originAccount"
                      options={originAccounts}
                      onChange={(e) => onChange({ name: 'originAccount', value: e.target.value })}
                      errors={errors}
                      tabIndex="8"
                      innerRef={register({
                        required: true,
                      })}
                    />
                  </FormGroup>
                </DetailRow>
                <DetailRow title="Cuenta y Banco Destino">
                  <FormGroup className="pr-4">
                    <WizardInput
                      className="pl-2"
                      type="select"
                      tag={CustomInput}
                      placeholder="Seleccionar"
                      id="destAccount"
                      name="destAccount"
                      options={destAccounts}
                      onChange={(e) => onChange({ name: 'destAccount', value: e.target.value })}
                      errors={errors}
                      tabIndex="9"
                      innerRef={register({
                        required: true,
                      })}
                    />
                  </FormGroup>
                </DetailRow>
              </Col>
            </Row>
          </form>
        ) : <></>}
      </CardBody>
    </Card>
  );
};

export default WireTransferSection;
